import { ASSETS, CLINIC } from "../lib/api";
import { Award, GraduationCap, Heart, ShieldCheck } from "lucide-react";

export default function About() {
  return (
    <div className="no-img-drag">
      <section className="bg-soft-cream emblem-watermark emblem-watermark-side" style={{"--emblem-url": `url('${ASSETS.emblem}')`}}>
        <div className="max-w-7xl mx-auto container-x py-16 lg:py-20 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-brand-red font-semibold text-xs uppercase tracking-[0.2em] mb-3">Despre medic</p>
            <h1 className="font-display font-extrabold text-brand-navy text-4xl sm:text-5xl lg:text-6xl tracking-tight">
              Dr. Cornelia Maria Biriș
            </h1>
            <p className="mt-3 text-brand-navy/65 font-medium text-lg">Medic Primar Stomatolog · Specialist în Stomatologie generală</p>

            <div className="mt-7 space-y-5 text-brand-navy/85 text-lg leading-relaxed font-light">
              <p className="text-brand-red font-semibold text-xs uppercase tracking-[0.2em]">CMI. Dr. Biriș Cornelia · Ro-Dental Cluj-Napoca</p>
              <p>
                Cabinetul Ro-Dental este un spațiu dedicat sănătății orale, unde experiența medicală se împletește cu grija pentru pacient și cu o abordare modernă, orientată spre rezultate de calitate.
              </p>
              <p>
                Coordonarea cabinetului este asigurată de medic primar stomatolog <strong className="text-brand-navy font-semibold">Cornelia Maria Biriș</strong>, cu o experiență profesională de peste 25 de ani în domeniul stomatologiei. De-a lungul timpului, parcursul său profesional a fost unul constant ascendent, bazat pe formare continuă, perfecționare și implicare în evoluția practicii stomatologice moderne.
              </p>
              <p>
                Specializarea principală este <strong>Stomatologia generală</strong>, completată de un <strong>masterat în Reabilitare orală</strong>, care permite abordarea complexă a cazurilor și realizarea unor planuri de tratament personalizate, adaptate fiecărui pacient.
              </p>
              <p>
                Prin experiență, precizie și atenție la detalii, cabinetul oferă servicii stomatologice realizate la standarde înalte, într-un mediu prietenos și orientat spre confortul pacientului.
              </p>
              <p className="text-brand-navy/70 text-base" data-testid="about-legal-status">
                <strong className="text-brand-navy">Statut legal:</strong> CMI Dr. Biriș Cornelia Maria își desfășoară activitatea independent în Cabinetul nr. 3, într-un spațiu medical închiriat.
              </p>
            </div>

            <blockquote className="mt-7 pl-5 border-l-2 border-brand-pink italic text-brand-navy font-light">
              „{CLINIC.motto}"
            </blockquote>
          </div>
          <div className="relative">
            <img
              src={ASSETS.poster}
              alt="Dr. Cornelia Maria Biriș la cabinet"
              className="w-full max-w-md mx-auto rounded-3xl shadow-2xl"
              draggable={false}
              data-testid="about-poster"
            />
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto container-x py-16 grid md:grid-cols-2 gap-10 items-center">
        <img
          src={ASSETS.drWarmCloseup}
          alt="Dr. Cornelia Maria Biriș, medic primar stomatolog — noul cabinet Ro-Dental Cluj-Napoca"
          className="rounded-3xl shadow-soft w-full max-w-md mx-auto md:mx-0"
          draggable={false}
          data-testid="about-warm-portrait"
        />
        <div>
          <h2 className="font-display font-extrabold text-brand-navy text-3xl sm:text-4xl tracking-tight">Experiență, prevenție, încredere</h2>
          <p className="mt-5 text-brand-navy/85 text-lg leading-relaxed">
            Cei peste 25 de ani de practică în stomatologie reprezintă fundamentul abordării noastre: tratamente moderne, protocoale stricte de igienă și sterilizare, comunicare transparentă cu fiecare pacient. Cabinetul Ro-Dental se află în relație contractuală cu Casa de Asigurări de Sănătate Cluj, oferind acces la servicii decontate pentru pacienții asigurați.
          </p>
        </div>
      </section>

      <section className="bg-brand-cream">
        <div className="max-w-7xl mx-auto container-x py-16">
          <h2 className="font-display font-extrabold text-brand-navy text-3xl sm:text-4xl tracking-tight text-center">Valorile noastre</h2>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            <Value icon={Heart} title="Empatie" text="Ascultăm fiecare pacient cu atenție și răbdare, înainte de orice intervenție." />
            <Value icon={ShieldCheck} title="Profesionalism" text="Tratamente moderne, materiale de calitate și protocoale stricte de igienă." />
            <Value icon={GraduationCap} title="Educație" text="Investiția în prevenție este cea mai eficientă pentru sănătatea orală pe termen lung." />
            <Value icon={Award} title="Experiență" text="Peste 25 de ani de practică stomatologică în Cluj-Napoca." />
          </div>
        </div>
      </section>
    </div>
  );
}

function Value({ icon: Icon, title, text }) {
  return (
    <div className="bg-white rounded-3xl p-6 border border-brand-yellow/40 shadow-sm">
      <div className="w-12 h-12 rounded-2xl bg-brand-yellow flex items-center justify-center text-brand-navy">
        <Icon className="w-6 h-6" />
      </div>
      <h3 className="mt-4 font-display font-bold text-brand-navy text-lg">{title}</h3>
      <p className="mt-2 text-sm text-brand-navy/70 leading-relaxed">{text}</p>
    </div>
  );
}
